import { userSupportedLanguages } from '../server/withUser';

export const convertIsoDate = (isoDateString: string | Date) => {
  const date = new Date(isoDateString);
  const language = userSupportedLanguages.includes(navigator.language)
    ? navigator.language
    : 'en-US';
  const month = date.toLocaleString(language, { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();
  if (language.includes('vi')) {
    return `ngày ${day} ${month} năm ${year}`.toLowerCase();
  } else if (language.includes('ja')) {
    return `${year}年${month}${day}日`;
  } else if (language.includes('fr')) {
    return `le ${day} ${month} ${year}`;
  } else if (language.includes('it')) {
    return `${day} ${month} ${year}`;
  }
  return `${month} ${day}, ${year}`;
};
